import BaseModulePlugins from '@/store/baseModule/plugins';

export default ({ module, store }) => {
  const basePlugin = new BaseModulePlugins({
    module,
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.onActiveRequestChange((request) => {
      store.dispatch(
        `${module}/setUrlParamIdAndClearFilters`,
        request.property_id
      );
    });
  });
};
